/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  CheckboxMarkCompleteCheckedIcon,
  CheckboxMarkCompleteUncheckedIcon,
} from '@sketchnote/icons';
import * as React from 'react';

const { memo } = React;

const MarkCompleteCell = ({ value }: { value: boolean }) => {
  return (
    <div className="flex items-center justify-center h-full w-full">
      {value ? (
        <CheckboxMarkCompleteCheckedIcon size={20} />
      ) : (
        <CheckboxMarkCompleteUncheckedIcon size={20} />
      )}
    </div>
  );
};

export const MarkCompleteCellRenderer = memo(MarkCompleteCell);
